import { Component, OnInit } from '@angular/core';
import { TemplateService } from '../../shared/services/template.service';
import { Router, Event, NavigationEnd } from '@angular/router';
import { AccessService } from '../../core/services/access.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
})
export class SideNavComponent implements OnInit {
  isCollapse: boolean;
  isLoggedIn: boolean = false;

  constructor(
    private tplSvc: TemplateService,
    private router: Router,
    public accessApi: AccessService,
  ) {
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (window.innerWidth < 992) {
          this.tplSvc.toggleSideNavCollapse(false);
        }
      }
    });
    this.accessApi.mee.subscribe((me) => {
      this.isLoggedIn = _.has(me, 'status') && me.status == 1 ? true : false;
    });
  }

  ngOnInit() {
    this.tplSvc.isSideNavCollapseChanges.subscribe((isCollapse) => {
      this.isCollapse = isCollapse;
    });
  }

  toggleSideNavCollapse() {
    this.isCollapse = !this.isCollapse;
    this.tplSvc.toggleSideNavCollapse(this.isCollapse);
  }
}
